export function setPageTitle(pageTitle) {
  if (pageTitle) {
    document.title = `${pageTitle} | Modo App Center`;
  } else {
    document.title = 'Modo App Center';
  }
}
